import { json } from "react-router-dom";

class ApiClient {
  constructor() {
    this.baseURL = process.env.REACT_APP_API_BASE_URL ;
 
  }

  async request(endpoint, method = 'GET', body = {}, headers = {}) {
    const config = {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        ...headers,
      },
      body: method !== 'GET' ? JSON.stringify(body) : null,
    };

  
    const url = this.baseURL+endpoint;

    try {
      const response = await fetch(url, config);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Fetch error:', error);
      throw error;
    }
  }

  get(endpoint, headers = {}) {
    return this.request(endpoint, 'GET', null, headers);
  }

  post(endpoint, body, headers = {}) {
    return this.request(endpoint, 'POST', body, headers);
  }

  put(endpoint, body, headers = {}) {
    return this.request(endpoint, 'PUT', body, headers);
  }

  delete(endpoint, headers = {}) {
    return this.request(endpoint, 'DELETE', null, headers);
  }
}

export default ApiClient;